import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Clock } from "lucide-react";

interface VerificationBadgeProps {
  type: string;
  verificationStatus?: string;
  className?: string;
}

export const getVerificationBadgeInfo = (type: string, verificationStatus?: string) => {
  if (type === "entreprise") {
    if (verificationStatus === "verified") {
      return { label: "Entreprise vérifiée", variant: "verified" as const, icon: ShieldCheck };
    }
    // pending or any other status for entreprise
    return { label: "Entreprise (vérification en cours)", variant: "warning" as const, icon: Clock };
  }
  return { label: "Artisan indépendant", variant: "bricoleur" as const, icon: null };
};

const VerificationBadge = ({ type, verificationStatus, className }: VerificationBadgeProps) => {
  const { label, variant, icon: Icon } = getVerificationBadgeInfo(type, verificationStatus);

  return (
    <Badge variant={variant} className={className}>
      {Icon && <Icon className="mr-1 h-3 w-3" />}
      {label}
    </Badge>
  );
};

export default VerificationBadge;
